import { type QuizBasedGameType, Subject } from '@app/data'

export const Pages = {
  ROOT: '/',
  LOGIN: '/login',

  // Library
  DICTIONARY: (language: string) => `/dictionary/${language}`,
  DISCOVERY: (language: string) => `/discovery/${language}`,

  // Game
  UNITY_GAME: '/game/unity',

  // Classroom
  CLASSROOMS: '/classrooms',
  NEW_CLASS: '/classrooms/new-class',
  CLASSROOM_DETAIL: (id: string) => `/classrooms/${id}`,
  CLASSROOM_LEARNING_PLAN: (id: string) => `/classrooms/${id}/learning-plan`,
  CLASSROOM_LEARNING_PLAN_PAGE: (id: string, learningPlanId: string, pageId: string) =>
    `/classrooms/${id}/learning-plan/${learningPlanId}/page/${pageId}`,
  CLASSROOM_UNIVERSAL_GAME_EDITOR: (id: string, activityId: string, subject: Subject, gameType: QuizBasedGameType) =>
    `/classrooms/${id}/universal-game-editor/${activityId}/${subject}/${gameType}`,
  CLASSROOM_PERFORMANCE: (id: string) => `/classrooms/${id}/performance`,
  CLASSROOM_MANAGE_CLASS: (id: string) => `/classrooms/${id}/manage-class`,
  CLASSROOM_MIGRATE_CLASS: (id: string) => `/classrooms/${id}/migrate-class`,
  CLASSROOM_SETUP_CLASS: (id: string) => `/classrooms/${id}/setup-class`
} as const
